"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fabricateLiquidationQueueRetractBid = void 0;
const terra_js_1 = require("@terra-money/terra.js");
const address_1 = require("../../utils/validation/address");
const validate_input_1 = require("../../utils/validate-input");
const number_1 = require("../../utils/validation/number");
const true_1 = require("../../utils/validation/true");
const amount_1 = require("../../utils/validation/amount");
const fabricateLiquidationQueueRetractBid = ({ address, bid_idx, amount }) => (addressProvider) => {
    (0, validate_input_1.validateInput)([
        (0, address_1.validateAddress)(address),
        amount ? (0, number_1.validateIsNumber)(amount) : true_1.validateTrue,
    ]);
    const mmContractAddress = addressProvider.liquidationQueue();
    return [
        new terra_js_1.MsgExecuteContract(address, mmContractAddress, {
            retract_bid: {
                bid_idx: bid_idx,
                amount: (0, amount_1.isAmountSet)(amount)
                    ? new terra_js_1.Int(new terra_js_1.Dec(amount).mul(1000000)).toString()
                    : undefined,
            },
        }),
    ];
};
exports.fabricateLiquidationQueueRetractBid = fabricateLiquidationQueueRetractBid;
//# sourceMappingURL=liquidation-queue-retract-bid.js.map